/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refineexamplefilmlook3Inputs */

const en_refineexamplefilmlook3 = /** @type {(inputs: Refineexamplefilmlook3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Film look`)
};

const de_refineexamplefilmlook3 = /** @type {(inputs: Refineexamplefilmlook3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filmlook`)
};

/**
* | output |
* | --- |
* | "Film look" |
*
* @param {Refineexamplefilmlook3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const refineexamplefilmlook3 = /** @type {((inputs?: Refineexamplefilmlook3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refineexamplefilmlook3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_refineexamplefilmlook3(inputs)
	return de_refineexamplefilmlook3(inputs)
});
export { refineexamplefilmlook3 as "refineExampleFilmLook" }